import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography, Button, Grid, MenuItem, Select, FormControl } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const SectionContainer = styled(Box)(({ theme }) => ({
  marginBottom: '20px',
  backgroundColor: '#F9FAFB',
  borderRadius: '16px',
  padding: '24px',
  border: '1px solid #EDF2F7',
  height: '100%',
  minHeight: '650px',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  overflow: 'visible',
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
    marginBottom: '12px',
    minHeight: 'auto',
  },
}));

const SectionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '16px',
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 800,
  color: '#2D3748',
  fontFamily: "'Poppins', 'Inter', sans-serif",
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-4px',
    left: '0',
    width: '32px',
    height: '3px',
    backgroundColor: '#996CFE',
    borderRadius: '2px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
  },
}));

const ViewAllButton = styled(Button)(({ theme }) => ({
  color: '#718096',
  textTransform: 'none',
  fontSize: '13px',
  fontWeight: 700,
  padding: '4px 12px',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #E2E8F0',
  boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
  '&:hover': {
    backgroundColor: '#F7FAFC',
    borderColor: '#CBD5E0',
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  height: '36px',
  minWidth: '110px',
  borderRadius: '10px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #E2E8F0',
  fontSize: '13px',
  fontWeight: 700,
  fontFamily: "'Poppins', 'Inter', sans-serif",
  '& .MuiSelect-select': {
    padding: '6px 32px 6px 12px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused': {
    boxShadow: '0 0 0 2px rgba(153, 108, 254, 0.1)',
  },
  '& .MuiSvgIcon-root': {
    color: '#996CFE',
    fontSize: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    height: '32px',
    minWidth: '90px',
    fontSize: '12px',
  },
}));

const TestSection = ({ title, filter, children, onViewAll }) => {
  const [filterValue, setFilterValue] = useState(filter?.defaultValue || '');

  const handleFilterChange = (event) => {
    setFilterValue(event.target.value);
    if (filter?.onChange) {
      filter.onChange(event.target.value);
    }
  };

  return (
    <SectionContainer>
      <SectionHeader>
        <SectionTitle>{title}</SectionTitle>
        <Box display="flex" alignItems="center">
          {filter && (
            <FormControl sx={{ mr: 2 }}>
              <StyledSelect
                value={filterValue}
                onChange={handleFilterChange}
                displayEmpty
                IconComponent={KeyboardArrowDownIcon}
              >
                {filter.options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </StyledSelect>
            </FormControl>
          )}
          
        </Box>
      </SectionHeader>
      <Box sx={{ pt: 0, mt: 0, flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </SectionContainer>
  );
};

export default TestSection; 